import GeneralFilter from '../../../../Model/GeneralFilter'

export default class UserFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
